import { ChangesUsers, User } from '../../types'
import { Alerts, PMChatState } from '../../types/mfc'
import { openMessage } from '../actions/message'
import { pubSub } from '../app-state/pubSub'
import { AppStateType, UserEvent } from '../constants/enums'
import { pubSubUsers } from './pubSub'
import { APPSTATE, updateAppState } from './state.app'
import { PMSTATE } from './state.pm'
import { USERSSTATE, idToSlug } from './state.users'

export function onChanges({ users }: { users: Array<ChangesUsers> }) {
    const alerts: Alerts = {}

    users.forEach((update) => {
        resolveUpdate(update)
        pubSubUsers.emit(UserEvent.UPDATE + '::' + update.id)
        pubSubUsers.emit(
            UserEvent.UPDATE + '::' + update.id + '::' + update.key,
        )
    })

    if (Object.keys(alerts).length) {
        updateAppState(AppStateType.ALERTS, { ...APPSTATE.alerts, ...alerts })
    }
}

function resolveUpdate<K extends keyof User>({
    delete: deleteKey,
    value,
    key,
    id,
}: {
    delete?: boolean
    value?: User[K]
    id: number
    key: K
}) {
    if (deleteKey) {
        //
        // Marc: If you change this behavior to allow deleted keys to emit
        // updates in the "pubSub.USERS.emit(`UPDATE:${key}`)" call below, you
        // will impact the subscribe/unsubscribe functionality in
        // "./app-state/state.room.ts". Deleting a key is only possible through
        // the "deleteKeys" option "updateFCSState" update in the worker.
        // Setting a value to "undefined" will not do the trick, as it shouldn't
        // for a number of reasons.
        //
        delete USERSSTATE?.[id][key]
        return
    }

    if (!USERSSTATE[id]) {
        USERSSTATE[id] = { id }
    }

    const slug = idToSlug[id]

    if (!slug) {
        console.warn('!! COULD NOT INDEX SLUG FOR:', id)
    }

    if (key === 'slug') {
        const previousSlug = USERSSTATE[id].slug
        const slug = value
        if (previousSlug && slug && previousSlug !== slug) {
            onModelNameChange({ id, slug })
        }
    }

    pubSub.USERS.emit(`UPDATE:${key}`, {
        previous: USERSSTATE[id][key],
        current: value,
        id,
    })

    USERSSTATE[id][key] = value
}

function onModelNameChange(payload: { id: number; slug: string }) {
    const { slug, id } = payload
    const { [id]: existingState = {} as PMChatState } = PMSTATE.chats
    const { isOpen } = existingState

    if (isOpen) {
        openMessage(slug)
    }
}
